const Modals = () => {
  const initModals = () => {
    $('body').find('[data-modal-link]').each(function() {
      const selector = $(this).data('modal-link');
      const modal = document.querySelector('[data-modal=' + selector + ']');

      const showModal = () => {
        $('html').css('overflow', 'hidden');
        modal.classList.remove('hidden');
      }

      const hideModal = () => {
        $('html').css('overflow', 'visible');
        modal.classList.add('hidden');
      }

      if (selector && modal) {
        const closeButton = $(modal).find('.js-close');

        closeButton.click(function () {
          hideModal();
        })
      }


      $(this).click(function (event) {
        event.preventDefault();
        if (selector && modal && modal.classList.contains('hidden')) {
          showModal();
        }
      })
    })
  }

  initModals();

  $(window).on('resize', function() {
    setTimeout(() => {
      initModals();
    }, 100);
  });
}

export default Modals;



// WEBPACK FOOTER //
// ./scripts/components/Modals.js